'use client';
import React, { memo, useCallback, useRef, useState } from 'react';

import { NextImage } from '@/app/_components';
import { useLang } from '@/hooks';
import { isSuccess, ServiceApi } from '@/services';
import emailjs from '@emailjs/browser';

import bg_contact from '../images/bg_contact.png';

import { Button, Form, Input, message } from 'antd';
import { getCookie, setCookie } from 'cookies-next';
import moment from 'moment';

const Item = Form.Item;
const { TextArea } = Input;

export const DescriptionContact = memo(() => {
	const { t } = useLang();
	const [loading, setLoading] = useState(false);
	let formRef = useRef<any>();

	const handleOk = async (values: any) => {
		try {
			setLoading(true);
			const res: any = await ServiceApi.createContact({
				...values,
				branchId: 1,
				createdAt: moment().format('hh:mm DD.MM.YYYY'),
			});

			const lastTimeSubscribe = getCookie('lastTimeSubscribe');
			const now = moment().unix();

			if (
				!lastTimeSubscribe ||
				now - Number(lastTimeSubscribe) > 60 * 5
			) {
				setCookie('lastTimeSubscribe', now.toString());

				if (isSuccess(res) && res.data?.id) {
					message.success(t('contact.message_success'));
					formRef.current.resetFields();
					try {
						emailjs.send(
							process.env.SERVICE_ID || 'service_qgtrwgp',
							process.env.TEMPLATE_ID || 'template_03brjka',
							values,
							process.env.PUBLIC_KEY || 'tCZzkwyatfXEmudtG'
						);
					} catch (e: any) {}
				} else {
					message.error(
						res.data?.error?.detail || t('contact.message_error')
					);
				}

				return;
			}
		} catch (e: any) {
			message.error(e.message || t('contact.message_error'));
		} finally {
			setLoading(false);
		}
	};

	const onOk = useCallback(() => {
		formRef.current
			.validateFields()
			.then((values: any) => {
				handleOk(values);
			})
			.catch((errorInfo: any) => {});
	}, []);

	return (
		<div
			className={'bg-cover bg-center object-center w-full'}
			style={{ backgroundImage: `url(${bg_contact.src})` }}
		>
			<div className={'container md:px-0 px-[2rem] md:p-10 py-4'}>
				<div className="relative">
					<Form
						ref={formRef}
						onFinish={onOk}
						initialValues={{}}
						className={
							'relative flex flex-col shadow-default bg-white p-6 md:w-[400px] rounded-default mx-auto z-10'
						}
					>
						<p
							className={
								'md:text-[24px] text-[20px] text-gray-7 font-bold whitespace-nowrap'
							}
						>
							{t('footer.contact.title')}
						</p>
						<p
							className={
								'max-md:text-[15px] text-gray-5 font-medium mt-1'
							}
						>
							{t('footer.contact.description')}
						</p>
						<div className={'flex flex-col mt-3'}>
							<Item
								name="name"
								className={'outline-none'}
								rules={[
									{
										required: true,
										message: t('contact.form_name'),
									},
								]}
							>
								<Input
									placeholder={t('footer.contact.input.1')}
									className="w-full text-sm h-[44px] px-3 text-gray-7 bg-white rounded-sm"
								/>
							</Item>
							<Item
								name="email"
								rules={[
									{
										required: true,
										message: t('contact.form_email'),
									},
								]}
								className={'outline-none'}
							>
								<Input
									placeholder={t('footer.contact.input.2')}
									className="w-full text-sm h-[44px] px-3 text-gray-7 bg-white rounded-sm"
								/>
							</Item>
							<Item
								name="phone"
								rules={[
									{
										required: true,
										message: t('contact.form_phone'),
									},
								]}
								className={'outline-none'}
							>
								<Input
									placeholder={t('footer.contact.input.3')}
									className="w-full text-sm h-[44px] px-3 text-gray-7 bg-white rounded-sm"
								/>
							</Item>
							<Item
								name={'message'}
								className={'outline-none'}
								rules={[
									{
										required: true,
										message: t('contact.form_message'),
									},
								]}
							>
								<TextArea
									rows={4}
									placeholder={t('footer.contact.input.4')}
									style={{ resize: 'none' }}
									className={
										'px-3 py-2 text-sm text-gray-7 bg-white rounded-sm'
									}
								/>
							</Item>
							<Button
								htmlType={'submit'}
								loading={loading}
								className={
									'bg-blue-2 rounded-sm !py-2 !text-white h-[44px] font-medium border-none'
								}
							>
								{t('footer.contact.btn')}
							</Button>
						</div>
					</Form>
					<div
						className={
							'w-[286px] absolute bottom-0 lg:left-[17%] max-md:hidden z-0'
						}
					>
						<NextImage
							src={require('../images/i_mail.png')}
							width={286}
						/>
					</div>
					<div
						className={
							'w-[100px] absolute top-0 lg:left-[17%] max-md:hidden z-0'
						}
					>
						<NextImage
							src={require('../images/i_phone_tiny.png')}
							width={100}
						/>
					</div>
					<div
						className={
							'w-[160px] absolute md:right-[10%] top-0 max-md:hidden z-0'
						}
					>
						<NextImage
							src={require('../images/i_phone_normal.png')}
							width={160}
						/>
					</div>
				</div>
			</div>
		</div>
	);
});
